export abstract class BaseFormatEvent {
  protected readonly _timestamp: number;

  public get timestamp() {
    return this._timestamp;
  }

  public get name() {
    return this._name;
  }

  constructor(protected readonly _name: string) {
    this._timestamp = Math.floor(Date.now() / 1000);
  }
}
